import { partition } from 'lodash';

function startsWithAny(str, arr) {
  for (let i = 0; i < arr.length; i++) {
    if (str.startsWith(arr[i])) {
      return true;
    }
  }
  return false;
}

export default {
  methods: {
    findError(path) {
      if (!this.errors) {
        return null;
      }

      const err = this.errors.find(e => e.path === path);
      if (!err) {
        return null;
      }

      return err.message;
    },

    filterErrors(prefix) {
      if (!this.errors || !this.errors.length) {
        return null;
      }

      if (!prefix) {
        return this.errors;
      }

      const prefixes = Array.isArray(prefix) ? prefix : [ prefix ];
      let [negatives, positives] = partition(prefixes, p => p.startsWith('!'));
      negatives = negatives.map(p => p.substring(1));

      const errors = this.errors.filter(e =>
          (!positives.length || startsWithAny(e.path, positives))
          &&
          (!negatives.length || !startsWithAny(e.path, negatives))
      );

      /*
      console.log('filterErrors(', prefix, ')');
      console.log('\terrors'   , this.errors);
      console.log('\tpositives', positives);
      console.log('\tnegatives', negatives);
      console.log('\tfiltered' , errors);
      */

      /*
      const ret = [];
      for (let i = 0; i < positives.length; i++) {
        prefix = positives[i];
        const err = errors.filter(e => e.path.startsWith(prefix));
        if (err && err.length) {
          ret.push(
            ...err.map(e => ({
              message: e.message,
              path: e.path.substring(prefix.length + 1)
            }))
          );
        }
      }

      //console.log('filterErrors(', prefixes, ') =', ret);
      return ret;
      */

      return errors;
    },

    countErrors(prefix) {
      const errors = this.filterErrors(prefix);
      if (!errors) {
        return 0;
      }
      return errors.length;
    }
  }
}
